<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="1200px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        rounded
        text
        small
        v-bind="attrs"
        v-on="on"
      >
        <v-icon left>mdi-cloud-download</v-icon>
        Download
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Download Acknowledgements</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row class="d-flex justify-center">
          <v-col cols="12">
            <v-progress-linear
              v-if="downloadStarted"
              :value="progress"
              :indeterminate="downloadingZip"
              rounded
              height="6"
            ></v-progress-linear>
          </v-col>
          <v-col cols="12">
            <span v-if="!downloadStarted">
              <v-btn rounded color="primary" @click="download">Start Download</v-btn>
            </span>
            <span v-else>
              <small>{{ downloadingText }}</small>
            </span>
          </v-col>
        </v-row>
        <v-container ref="pdf" class="pt-0">
          <div v-if="currentAck">
            <ColorBanner />
            <v-container>
              <v-row class="d-flex align-top">
                <v-col class="shrink">
                  <img src="@/assets/logo.png" height="80px">
                </v-col>
                <v-col class="grow">
                  <h1>{{ currentAck.session.fields.Name }}</h1>
                  <p>
                    Please acknowledge that you attended and understood
                    the training contents by typing your name in the field
                    below exactly as it appears here: 
                    {{ currentAck.employee.fields.Name }}
                  </p>
                </v-col>
              </v-row>
              <v-row class="d-flex justify-center">
                <v-col style="max-width: 768px;">
                  <v-text-field
                    :value="currentAck.employee.fields.Name"
                    :hint="formatTimestamp(currentAck)"
                    persistent-hint
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { jsPDF } from 'jspdf'
  import jsZip from 'jszip'
  import { saveAs } from 'file-saver'
  import moment from 'moment'
  import ColorBanner from '@/components/Banner'
   
  export default {
    name: 'AcknowledgementDownload',
    props: {
      acknowledgements: Array
    },
    components: {
      ColorBanner
    },
    data () {
      return {
        currentAck: null,
        dialog: false,
        downloadingText: '',
        downloadingZip: false,
        downloadStarted: false,
        progress: 0,
      }
    },
    methods: {
      async download () {
        this.downloadStarted = true
        let zip = new jsZip()
        for (let [index, ack] of this.acknowledgements.entries()) {
          this.downloadingText = 'Rendering PDF ' + (index + 1) + 
                                 ' of ' + this.acknowledgements.length
          this.currentAck = ack
          const filename = this.currentAck.employee.fields.Name + ' - ' + 
                           this.currentAck.session.fields.Name + '.pdf'
          
          const canvas = await this.$html2canvas(this.$refs.pdf, {
            type: 'dataURL'
          })
          let pdf = new jsPDF('p', 'mm', 'a4')
          pdf.addImage(canvas, 'PNG', 0, 0, 211, 50)
          zip.file(filename, pdf.output('blob'))
          this.progress = (index + 1) / this.acknowledgements.length * 100
        }
        this.downloadingText = 'Zipping up your files...'
        this.downloadingZip = true
        zip.generateAsync({ type: 'blob' })
        .then(content => {
          saveAs(content, 'acknowledgements.zip')
          this.dialog = false
          this.downloadingZip = false
          this.$store.dispatch('setSnackbar', {
            snackbarColor: 'success',
            showSnackbar: true,
            snackbarY: 'top',
            snackbarX: 'right',
            snackbarText: `Successfully downloaded acknowledgements!`
          })
          this.reset()
        })
      },
      formatTimestamp (ack) {
        return moment(ack.fields['Acknowledged Date Time']).format('LLL')
      },
      reset () {
        this.currentAck = null
        this.downloadingText = ''
        this.downloadingZip = false
        this.downloadStarted = false
        this.progress = 0
      }
    }
  }
</script>
